// Vendor imports
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('TopCallToActionExplainerButtons')

function TopCallToActionExplainerButtons(props) {
  return tag('div', {
    className: bem.block()
  },
    tag('button', {
      className: bem.element('button', 'primary'),
      onClick: props.onPrimaryClick
    },
      `Join Mix`
    ),
    props.onSecondaryClick && tag('button', {
      className: bem.element('button', 'secondary'),
      onClick: props.onSecondaryClick
    },
      `Sign in`
    )
  )
}

TopCallToActionExplainerButtons.propTypes = {
  // Callbacks
  onPrimaryClick: PropTypes.func,
  onSecondaryClick: PropTypes.func
}

module.exports = TopCallToActionExplainerButtons
